import React from 'react'
import axios from 'axios'
import './style.css'

const API = '/content/uamtool/'
class UAMigrationApp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      url: '',
      html: '',
      html2: '',
      links: [],
      countriesListArr: {},
      loading: false,
      loading2: false,
      urls: {
        names: [],
        urls: [],
        visited: [],
        html: [],
        layout: [],
        properties: [],
        htmlIn: [],
        layoutIn: [],
        propertiesIn: [],
        json: [],
        jsonIn: [],
        htmlLinks: [],
      },
      urlsFiles: false,
      loadingCountries: true,
      strategyId: true,
      totalpages: 0,
    }

    this.clearLink = this.clearLink.bind(this)
    this.alterLink2 = this.alterLink2.bind(this)
    this.inputChange = this.inputChange.bind(this)
    this.handleStrategyChange = this.handleStrategyChange.bind(this)
    this.getTotalPages = this.getTotalPages.bind(this)

    this.saveOnlineHTMLByStrategy = this.saveOnlineHTMLByStrategy.bind(this)
    this.getBodyOnlineHTML = this.getBodyOnlineHTML.bind(this)
    this.loadLocalFileHTML = this.loadLocalFileHTML.bind(this)
    this.loadLocalFileHTMLRoot = this.loadLocalFileHTMLRoot.bind(this)
    this.removeLocalExtraTags = this.removeLocalExtraTags.bind(this)
    this.prettyHTML = this.prettyHTML.bind(this)
    this.createLayProp = this.createLayProp.bind(this)
    this.getListOfLanguageURLs = this.getListOfLanguageURLs.bind(this)
    this.loadFileDetails = this.loadFileDetails.bind(this)
    this.getCountriesList = this.getCountriesList.bind(this)
    this.getListOfLanguageURLsCounts = this.getListOfLanguageURLsCounts.bind(
      this,
    )

    // this.sumbitLinkOld = this.sumbitLinkOld.bind(this);
    // this.saveToHTMLFromOnline = this.saveToHTMLFromOnline.bind(this);
    // this.saveInsideLinks = this.saveInsideLinks.bind(this);
    this.removeAttrLocalFileHTML = this.removeAttrLocalFileHTML.bind(this)
    // this.serveNoAttrLocalHtml = this.serveNoAttrLocalHtml.bind(this);
    // this.createLayPropNoAttr = this.createLayPropNoAttr.bind(this);
  }
  componentDidMount() {
    this.getCountriesList()
  }

  // getCountriesList() {
  //   axios
  //     .post(API + 'getListOfLanguageURLs', {})
  //     .then(result => {
  //

  //       if(result.data.sys){
  //         delete result.data.sys;
  //       }

  //       this.setState({
  //         countriesListArr: result.data,
  //         loadingCountries: false,
  //       })
  //     })
  //     .catch(er => {
  //       if (er) {
  //
  //         // setTimeout(() => {
  //         //     this.getCountriesList()
  //         // }, 500);
  //       }
  //     })
  // }

  getTotalPages() {
    let total = 0
    Object.keys(this.state.countriesListArr).map(key => {
      // this.countriesListArr[key][2]
      total = total + this.state.countriesListArr[key][2]
    })
    this.setState({
      totalpages: total,
    })
  }

  getCountriesList() {
    axios.get(API + 'getCountriesList', {}).then(result => {
      if (result.data.sys) {
        delete result.data.sys
      }

      this.setState({
        countriesListArr: result.data,
        loadingCountries: false,
      })
      this.getCountriesListCount()
    })
  }
  getCountriesListCount() {
    axios
      .get(API + 'getListOfLanguageURLsCounts', {})
      .then(result => {
        if (result.data.sys) {
          delete result.data.sys
        }

        this.setState({
          countriesListArr: result.data,
          loadingCountries: false,
        })
        setTimeout(() => {
          this.getTotalPages()
        }, 500)
      })
      .catch(er => {
        if (er) {
          // setTimeout(() => {
          //     this.getCountriesList()
          // }, 500);
        }
      })
  }
  handleStrategyChange(event) {
    this.setState({ strategyId: event.target.value })
  }
  saveOnlineHTMLByStrategy() {
    event.preventDefault()
    this.setState({ loading: true, loading2: true })

    let data = { url: this.state.url, strategyId: this.state.strategyId }
    axios.get(API + 'saveOnlineHTMLByStrategy', { params: data }).then(() => {
      this.loadLocalFileHTML()
      this.loadFileDetails()
    })
  }

  loadFileDetails() {
    // event.preventDefault()
    this.setState({ urlsFiles: true })
    let data = { urls: this.state.urls }

    axios.get(API + 'loadFileDetails', { params: data }).then(result => {
      this.setState({
        urls: result.data,
        urlsFiles: false,
      })
    })
  }

  getBodyOnlineHTML() {
    event.preventDefault()
    this.setState({ loading: true, loadin2: true })
    let data = { url: this.state.url }
    axios
      .get(API + 'getBodyOnlineHTML', { params: data })
      .then(result => {
        this.setState({
          html: result.data,
          loading: false,
        })
      })
      .catch(er => {
        if (er) {
          setTimeout(() => {
            this.getBodyOnlineHTML()
          }, 1000)
        }
      })
  }

  loadLocalFileHTML() {
    event.preventDefault()
    this.setState({ loading2: true, loading: true })
    let data = { url: this.state.url }
    axios.get(API + 'loadLocalFileHTML', { params: data }).then(result => {
      this.setState({
        html2: result.data,
        loading2: false,
      })
      this.getBodyOnlineHTML()
    })
  }

  loadLocalFileHTMLRoot() {
    event.preventDefault()
    this.setState({ loading2: true, loading: true })
    let data = { url: this.state.url }
    axios.get(API + 'loadLocalFileHTMLRoot', { params: data }).then(result => {
      this.setState({
        html2: result.data,
        loading2: false,
      })
      this.getBodyOnlineHTML()
    })
  }

  prettyHTML() {
    event.preventDefault()
    this.setState({ loading2: true, loading: true })
    let data = { url: this.state.url }
    axios.post(API + 'prettyHTML', data).then(result => {
      this.setState({
        html2: result.data,
        loading2: false,
      })
    })

    this.getBodyOnlineHTML()
  }

  removeLocalExtraTags() {
    event.preventDefault()
    this.setState({ loading2: true, loading: true })
    let data = { url: this.state.url }
    axios.post(API + 'removeLocalExtraTags', data).then(result => {
      this.setState({
        html2: result.data,
        loading2: false,
      })
    })

    this.getBodyOnlineHTML()
  }

  createLayProp() {
    event.preventDefault()
    this.setState({ loading2: true, loading: true })
    let data = { url: this.state.url }
    axios.get(API + 'createLayProp', { params: data }).then(result => {
      this.setState({
        html2: result.data,
        loading2: false,
      })
    })
    // this.loadFileDetails()
    // this.getBodyOnlineHTML()
  }

  getListOfLanguageURLsCounts() {
    event.preventDefault()
    this.setState({ loadingCountries: true })
    // let data = { data: this.state.countriesListArr }
    return new Promise(res1 => {
      axios.get(API + 'getListOfLanguageURLsCounts').then(result => {
        //
        // result.data.names.length;
        res1(result.data.names.length)
      })
    })
  }

  getListOfLanguageURLs(local) {
    event.preventDefault()
    this.setState({ loadingCountries: true })
    let data = { url: this.state.countriesListArr[local][0] }
    //
    axios.get(API + 'getListOfLanguageURLs', { params: data }).then(result => {
      //
      //
      // let d = ``
      // result.data.urls.map(ur => {
      //   //ur.split("/").pop().split("?").pop().split("=").pop()
      //   //
      //   // if(ur.split("/") && ur.split("/").pop().split("?") && ur.split("/").pop().split("?").pop().split("="))
      //   // d+=ur+"\n"
      //   // d += `\n${ur},${ur
      //   //   .split('/')
      //   //   .pop()
      //   //   .split('?')
      //   //   .pop()
      //   //   .split('=')
      //   //   .pop()}`
      // })
      //
      this.setState({
        urls: result.data,
        loadingCountries: false,
      })
      setTimeout(() => {
        //
        this.loadFileDetails()
      }, 200)
    })
  }

  inputChange(event) {
    this.setState({
      url: event.target.value,
    })
  }
  alterLink(i, loc) {
    this.setState(prevState => ({
      ...prevState,
      url: prevState.links[loc][i],
      html: '',
    }))
  }
  alterLink3(lnk, ind) {
    this.setState({
      url: lnk,
      html: '',
      html2: '',
    })
    this.setState(preState => ({
      ...preState,
      urls: {
        ...preState.urls,
        visited: {
          ...preState.urls.visited,
          [ind]: true,
        },
      },
    }))
  }
  alterLink2(loc) {
    this.setState(prevState => ({
      ...prevState,
      url: prevState.countriesListArr[loc][0],
      html: '',
    }))
    this.setState(prevState => ({
      ...prevState,
      countriesListArr: {
        ...prevState.countriesListArr,
        [loc]: [
          prevState.countriesListArr[loc][0],
          true,
          prevState.countriesListArr[loc][2],
        ],
      },
    }))

    this.getListOfLanguageURLs(loc)
  }
  clearLink() {
    this.setState(prevState => ({
      ...prevState,
      url: '',
    }))
  }

  // sumbitLinkOld() {
  //     event.preventDefault();
  //     this.setState({ loading: true });
  //     let data = { url: this.state.url }
  //     axios.post(API + "htmlOld", data)
  //         .then(result => {
  //
  //             this.setState({
  //                 html: result.data,
  //                 loading: false
  //             })
  //         }
  //         )
  // }

  removeAttrLocalFileHTML() {
    event.preventDefault()
    this.setState({ loading2: true, loading: true })
    let data = { url: this.state.url }
    axios.post(API + 'removeAttrLocalHtml', data).then(result => {
      this.setState({
        html2: result.data,
        loading2: false,
      })
    })
    this.getBodyOnlineHTML()
  }

  // createLayPropNoAttr() {
  //     event.preventDefault();
  //     this.setState({ loading2: true, loading:true });
  //             let data = { url: this.state.url }
  //             axios.post(API + "createLayPropNoAttr", data)
  //                 .then(result => {
  //
  //                     this.setState({
  //                         html2: result.data,
  //                         loading2: false
  //                     })
  //                 }
  //                 )
  // this.getBodyOnlineHTML();

  // }

  // serveNoAttrLocalHtml() {
  //     event.preventDefault();
  //     this.setState({ loading2: true, loading:true });
  //             let data = { url: this.state.url }
  //             axios.post(API + "serveNoAttrLocalHtml", data)
  //                 .then(result => {
  //
  //                     this.setState({
  //                         html2: result.data,
  //                         loading2: false
  //                     })
  //                 }
  //                 )
  // this.getBodyOnlineHTML();

  // }
  // saveToHTMLFromOnline() {
  //     event.preventDefault();
  //     this.setState({ loading: true, html2:"", loading2: "" });
  //     let data = { url: this.state.url }
  //     axios.post(API + "saveHtml", data)
  //         .then(result => {
  //
  //             this.setState({
  //                 html: result.data,
  //                 loading: false
  //             })
  //         }
  //         )
  // }
  // saveInsideLinks() {
  //     event.preventDefault();
  //     this.setState({ loading: true });
  //     let data = { url: this.state.url }
  //     axios.post(API + "saveInsideHtml", data)
  //         .then(result => {
  //
  //             this.setState({
  //                 html: result.data,
  //                 loading: false
  //             })
  //         }
  //         )

  // }

  render() {
    return (
      <div className="container1">
        <h1>Welcome to UA Migration Tool 1.0 !</h1>

        <div>
          {this.state.totalpages === 0 ? (
            <span className="loadingAnimation2" />
          ) : (
            <span className="totalCounted">
              Total sub-pages:{' '}
              <span className="numCounter">{this.state.totalpages}</span>
            </span>
          )}
        </div>

        <div>
          {Object.keys(this.state.countriesListArr).map((itm, ind) => {
            return (
              <span
                key={`spn${ind}`}
                className={`btnLinkTypes${
                  this.state.countriesListArr[itm][1] === true ? 'CC' : ''
                }`}
                name="en_EN"
                onClick={() => this.alterLink2(itm)}
              >
                <span>{itm}</span>

                {this.state.countriesListArr[itm][2] === 0 ? (
                  <span className="loadingAnimation2" />
                ) : (
                  <span className="numCounter">
                    {this.state.countriesListArr[itm][2]}
                  </span>
                )}
              </span>
            )
          })}
        </div>
        <div className="links">
          {this.state.loadingCountries ? (
            <div className="loadingAnimation">
              <div />
              <div />
              <div />
              <div />
            </div>
          ) : (
            this.state.urls.names.map((itm, ind) => {
              return (
                <button
                  key={`bt${ind}`}
                  className={`${
                    this.state.urls.urls[ind].indexOf('paypal.com') > -1 ||
                    this.state.urls.urls[ind].indexOf('paypalobjects.com') > -1
                      ? ''
                      : 'notpaypal '
                  }${
                    this.state.urls.urls[ind].indexOf('pdf') > -1
                      ? 'lnkpdf '
                      : ''
                  }properties2${
                    this.state.urls.propertiesIn[ind] ? 'yes' : 'no'
                  } properties${
                    this.state.urls.properties[ind] ? 'yes' : 'no'
                  } json${this.state.urls.json[ind] ? 'yes' : 'no'} json2${
                    this.state.urls.jsonIn[ind] ? 'yes' : 'no'
                  } layout2${
                    this.state.urls.layoutIn[ind] ? 'yes' : 'no'
                  } layout${this.state.urls.layout[ind] ? 'yes' : 'no'} html2${
                    this.state.urls.htmlIn[ind] ? 'yes' : 'no'
                  } html${
                    this.state.urls.html[ind] ? 'yes' : 'no'
                  } btnLinkTypes2${this.state.urls.visited[ind] ? 'CC' : ''}`}
                  name={`btnLink2${ind}`}
                  onClick={() =>
                    this.alterLink3(this.state.urls.urls[ind], ind)
                  }
                >
                  {itm}
                </button>
              )
            })
          )}
        </div>
        {this.state.url ? (
          <a target="_blank" rel="noopener noreferrer" href={this.state.url}>
            Live Link
          </a>
        ) : (
          ''
        )}

        <input
          className="UAlink"
          value={this.state.url}
          placeholder="Insert your link..."
          type="text"
          name="url"
          onChange={this.inputChange}
        />
        {this.state.url ? (
          <button
            className="btnRefresh"
            name="submit"
            type="submit"
            onClick={this.loadFileDetails}
          >
            Refresh
          </button>
        ) : (
          ''
        )}
        <button className="btnA" name="btnClear" onClick={this.clearLink}>
          clear
        </button>
        <br />
        {this.state.url ? (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={'../content/ua/' + this.state.url.split('/').pop()}
          >
            Local Link
          </a>
        ) : (
          ''
        )}

        <br />
        <br />
        <label>
          Strategy:
          <select
            className="strategySelect"
            value={this.state.strategyId}
            onChange={this.handleStrategyChange}
          >
            <option value="0">Do not Save Anything</option>
            <option value="1">Body without header footer and scripts</option>
            <option value="2">
              [Enahnced]Body without header footer and scripts
            </option>
            <option value="3">[no Attribute Policy]</option>
            <option value="33">[no Attribute Policy] + Download Link</option>
            <option value="5">Save All HTML DOM</option>
            <option value="4">Save Head and Body Seperately</option>
          </select>
        </label>
        <button
          className="btnStrategy"
          disabled={!this.state.url}
          name="submit"
          type="submit"
          onClick={this.saveOnlineHTMLByStrategy}
        >
          Save HTML from Online - By Strategy
        </button>
        <button
          className="btnA"
          disabled={!this.state.url}
          name="submit"
          type="submit"
          onClick={this.removeLocalExtraTags}
        >
          Remove Local Extra Tags
        </button>
        <button
          className="btnA"
          disabled={!this.state.url}
          name="submit"
          type="submit"
          onClick={this.createLayProp}
        >
          Generate .Layout .Properties and .JSON
        </button>
        <br />
        <button
          className="btnA"
          disabled={!this.state.url}
          name="submit"
          type="submit"
          onClick={this.getBodyOnlineHTML}
        >
          Online HTML
        </button>

        {/*<button className="btnA" name="submit" type="submit" onClick={this.sumbitLinkOld}>Analyze HTML Old Script</button> */}
        {/* <button className="btnA" name="submit" type="submit" onClick={this.saveToHTMLFromOnline}>Save Online HTML to ./ Folder</button> */}
        {/* <button className="btnA" name="submit" type="submit" onClick={this.removeAttrLocalFileHTML}>Remove Attributes</button> */}
        {/* <button className="btnA" name="submit" type="submit" onClick={this.saveInsideLinks}>Save Inside Links at JSONDB</button>    */}
        {/* <button className="btnLocal" name="submit" type="submit" onClick={this.serveNoAttrLocalHtml}>Load ./noAttr File</button> */}
        {/* <button className="btnA" name="submit" type="submit" onClick={this.createLayPropNoAttr}>Layout and Properties ./noAttr</button> */}

        <button
          className="btnLocal"
          disabled={!this.state.url}
          name="submit"
          type="submit"
          onClick={this.loadLocalFileHTML}
        >
          Load Local HTML File
        </button>
        <button
          className="btnLocal"
          disabled={!this.state.url}
          name="submit"
          type="submit"
          onClick={this.loadLocalFileHTMLRoot}
        >
          Load Local ROOT HTML File
        </button>
        {/* <button
          className="btnA"
          name="submit"
          type="submit"
          onClick={this.prettyHTML}
        >Pretty HTML File
        </button> */}

        <br />
        <div className="content">
          <div className="contentSplit ">
            <div className="contentOnline">--Online Contents--</div>
            <div
              dangerouslySetInnerHTML={
                this.state.loading
                  ? {
                      __html:
                        '<div class="loadingAnimation"><div></div><div></div><div></div><div></div></div>',
                    }
                  : { __html: this.state.html }
              }
            />
          </div>
          <div className="contentSplit">
            <div className="contentLocal">--Local Contents--</div>
            <div
              dangerouslySetInnerHTML={
                this.state.loading2
                  ? {
                      __html:
                        '<div class="loadingAnimation"><div></div><div></div><div></div><div></div></div>',
                    }
                  : { __html: this.state.html2 }
              }
            />
          </div>
        </div>
      </div>
    )
  }
}
export default UAMigrationApp
